module.exports = __webpack_public_path__ + "img/511.a0766397.png";